import {
  Box,
  FormControlLabel,
  Radio,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { RadioGroupWrapper } from "./curatorApprovalStyle";
import useThemeRender from "../../../theme/useThemeRender";

const CustomCuratorRadioGroup = ({
  label,
  radioGroup = [],
  onChange,
  value,
  required = false,
  name,
}) => {
  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: "8px" }}
      data-testid={name ? `radio-group-${name}` : undefined}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: { xs: "300px", md: "400px" },
          maxWidth: "100%",
          marginBottom: 1,
        }}
      >
        <Typography
          variant="subtitle1"
          component="label"
          sx={{
            marginBottom: 0,
            fontSize: "12px",
            fontWeight: 400,
            fontFamily: "Inter",
            lineHeight: "20px",
            color: useThemeRender("textColorLayer2"),
          }}
        >
          {label}
        </Typography>
        {required && (
          <Typography
            variant="subtitle1"
            sx={{
              marginBottom: 0,
              fontSize: "12px",
              fontWeight: 400,
              fontFamily: "Inter",
              lineHeight: "20px",
              color: "#616161",
            }}
          >
            *Required
          </Typography>
        )}
      </Box>
      <RadioGroupWrapper
        row={!isMobile}
        onChange={onChange}
        sx={{
          gap: isMobile ? "8px" : "32px",
          "& .MuiTypography-root": {
            color: useThemeRender("textColorLayer4"),
          },
        }}
      >
        {radioGroup?.map((radioItem) => (
          <FormControlLabel
            key={radioItem?.id}
            value={radioItem?.id}
            control={<Radio />}
            label={radioItem?.label}
            checked={radioItem?.id === value}
          />
        ))}
      </RadioGroupWrapper>
    </Box>
  );
};

export default CustomCuratorRadioGroup;
